import React from 'react';
import HeroSection from "../alumnicomponents/HeroSection";
import ProfileHighlight from "../alumnicomponents/ProfileHighlight";
import UpEvents from "../alumnicomponents/UpEvents";
import JoinTISA from "../alumnicomponents/JoinTISA";

const AlumniHome = () => {
  return (
    <>
      <section >
        <div className="flex flex-col">
          <HeroSection/>
          <ProfileHighlight />
          <UpEvents />
        </div>
      </section>
    </>
  );
};

export default AlumniHome;
